import React, { useRef, useEffect } from "react";
import PropTypes from "prop-types";

const DeleteModal = ({ isOpen, onClose, onDelete, title, message }) => {
  const alertRef = useRef(null);

  const handleClickOutside = (event) => {
    if (alertRef.current && !alertRef.current.contains(event.target)) {
      onClose();
    }
  };

  useEffect(() => {
    if (isOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isOpen]);

  if (!isOpen) return null;

  const modalStyle = {
    overlay: {
      position: "fixed",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: "rgba(0, 0, 0, 0.5)",
      opacity: 1,
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      zIndex: 9999,
    },
    modal: {
      backgroundColor: "#ffffff",
      padding: "40px",
      borderRadius: "16px",
      boxShadow: "0 4px 6px rgba(0, 0, 0, 1)",
      width: "436px",
      height: "228px",
      textAlign: "center",
    },
  };

  return (
    <div style={modalStyle.overlay}>
      <div ref={alertRef} style={modalStyle.modal}>
        <div style={{ color: "#ffffff" }}>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <div
              style={{
                fontSize: "20px",
                fontWeight: "700",
                color: "#1E1E1E",
              }}
            >
              {title}
            </div>
            <div
              style={{
                marginTop: "8px",
                fontSize: "16px",
                fontWeight: "400",
                color: "#1E1E1E",
              }}
            >
              {message}
            </div>

            <div
              style={{
                flex: 12,
                marginTop: "8px",
                display: "flex",
                flexDirection: "row",
                alignItems: "start",
                justifyContent: "start",
              }}
            >
              <button
                type="button"
                onClick={onClose}
                style={{
                  width: "158px",
                  height: "44px",
                  marginLeft: "8px",
                  marginRight: "8px",
                  borderRadius: "8px",
                  display: "flex",
                  flex: 6,
                  justifyContent: "center",
                  alignItems: "center",
                  border: "1px solid #E5E5E5",
                  cursor: "pointer",
                  backgroundColor: "#FFFFFF",
                }}
              >
                <span
                  style={{
                    fontSize: "16px",
                    fontWeight: "500",
                    color: "#1E1E1E",
                  }}
                >
                  Cancel
                </span>
              </button>
              <button
                type="button"
                onClick={onDelete}
                style={{
                  width: "158px",
                  height: "44px",
                  marginLeft: "8px",
                  marginRight: "8px",
                  borderRadius: "8px",
                  display: "flex",
                  flex: 6,
                  justifyContent: "center",
                  alignItems: "center",
                  background: "#FF4444",
                  cursor: "pointer",
                  border: "none",
                }}
              >
                <span
                  style={{
                    fontSize: "16px",
                    fontWeight: "500",
                    color: "#FFFFFF",
                  }}
                >
                  Delete
                </span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

DeleteModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  message: PropTypes.string.isRequired,
};

export default DeleteModal;
